// extracted by mini-css-extract-plugin
export default {"inline":"inline__2vbGo","text":"text__UW6VF","icon":"icon__QmqPt"};